package home

import base.SRProps
import com.jingfangpai.api.clients.DiagnosisApiClient
import com.jingfangpai.api.clients.MedicalRecordApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.medicalRecord.model.MedicalRecordRawData
import com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem
import react.*
import react.dom.div
import user.service.AuthService

external interface HomePageProps : SRProps {

}

data class HomePageContextData(
    var getOptions:(okCallback: (result: ApiResponse<Array<CascadedOption<String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var getNextDiagnosisItem:(medicalRecordRawData: MedicalRecordRawData, okCallback: (result: ApiResponse<Array<DiagnosisQuestionAndAnswerItem>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveFromRawData:(medicalRecordRawData:MedicalRecordRawData, okCallback: (result:ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val HomePageContext = createContext(HomePageContextData(SignSymptomApiClient::getOptions, DiagnosisApiClient::getNextDiagnosisItem,MedicalRecordApiClient::saveFromRawData))

val HomePageProvider = functionalComponent<HomePageProps> { props ->

    HomePageContext.Provider(HomePageContextData(SignSymptomApiClient::getOptions, DiagnosisApiClient::getNextDiagnosisItem,MedicalRecordApiClient::saveFromRawData)) {
        div("HomePage-page") {
            child(Home){
                attrs{
                    userId = AuthService.getUserAuthData()?.id
                }
            }
        }
    }
}

@JsExport
fun getHomePageSsrProps(props: HomePageProps,okCallback:(Throwable?,HomePageProps)->Unit){
    console.log("getHomePageSsrProps called")
    /*TestDataSource.getContent({error,_content->
        okCallback(error, props.apply { defaultContent = _content?:"no content" })
    })*/
}
